import { ContentBlockViewComponent, ContentModule } from '@tytapp/content';
import { ContinueWatchingBlock } from './continue-watching-block';
import { Component, DestroyRef, inject } from '@angular/core';
import { MediaUiModule } from '../media-ui.module';
import { UserService } from '@tytapp/user';
import { ApiUser } from '@tytapp/api';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'tyt-continue-watching-block',
    standalone: true,
    imports: [ MediaUiModule, ContentModule ],
    template: `
        @if (user) {
            <tyt-content-card title="Continue Watching" [icon]="{ type: 'material', text: 'play_arrow' }">
                <tyt-continue-watching />
            </tyt-content-card>
        }
    `,
    styles: [`
        // TODO
    `]
})
export class ViewComponent extends ContentBlockViewComponent<ContinueWatchingBlock> {
    private readonly destroy: DestroyRef = inject(DestroyRef);
    private userService = inject(UserService);
    user: ApiUser;

    async ngOnInit() {
        this.userService.userChanged.pipe(takeUntilDestroyed(this.destroy)).subscribe(user => this.user = user);
    }
}
